import React from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";

const MeetingBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid ctm-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
          {/* Preloaded Image for Faster Rendering */}
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/8.%20Meeting%20&%20Events.webp"
            alt="Meeting & Events Banner"
            className="w-100"
            loading={useHighRes ? "eager" : "lazy"}
            onLoad={handleImageLoad}
            fetchpriority={useHighRes ? "high" : "auto"}
          />

          {imageLoaded ? (
            <div className="ctm-text position-absolute text-white mt-xxl-4 mt-3">
              <p className="fs4 text-uppercase busy">Effortless</p>
              <h1 className="banner-headings w-100">
                Unforgettable Meetings{" "}
                <span className="text-white" style={{ fontWeight: "bold" }}>
                  &{" "}
                </span>
                <br /> Events Await
              </h1>
              <div className="d-flex common-second-content">
                <div className="ornge-border"></div>
                <div className="second-content">
                  Looking for more than just a venue? From conferences to
                  corporate retreats, we offer unmatched event planning to turn
                  your corporate gathering into an extraordinary experience.
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </BannerWrapper>
  );
};

export default MeetingBanner;
